import { createRouter, createWebHistory } from 'vue-router'
import ShareLanding from '@/views/ShareLanding.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/p/demo' },
    { path: '/p/:shareCode', name: 'share', component: ShareLanding },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
})

export default router
